import {BaseData} from '../base/static_config_data/BaseData';
import {BackgroundDataEvent} from './background_data/BackgroundDataEvent';
import {ActiveData} from '../../ActiveData';

export class BackgroundData extends BaseData
{
    constructor(private config: IBackgroundData) {
        super();
    }

    get color(): string {
        return this.config.color;
    }

    set color(value: string) {
        this.config.color = value;
        ActiveData.addEventToPool<string>(this, BackgroundDataEvent.COLOR_CHANGED, this.config!.color);
    }

    get image(): string {
        return this.config.image;
    }

    set image(value: string) {
        this.config.image = value;
        ActiveData.addEventToPool<string>(this, BackgroundDataEvent.IMAGE_CHANGED, this.config!.image);
    }

    get pattern(): PatternRepeat  {
        return this.config.pattern;
    }

    set pattern(value: PatternRepeat) {
        this.config.pattern = value;
        ActiveData.addEventToPool<PatternRepeat>(this, BackgroundDataEvent.PATTERN_CHANGED, this.config!.pattern);
    }

    get width(): number {
        return this.config.width;
    }

    set width(value: number) {
        this.config.width = value;
        ActiveData.addEventToPool<number>(this, BackgroundDataEvent.WIDTH_CHANGED, this.config!.width);
    }

    get height(): number {
        return this.config.height;
    }

    set height(value: number) {
        this.config.height = value;
        ActiveData.addEventToPool<number>(this, BackgroundDataEvent.HEIGHT_CHANGED, this.config!.height);
    }
}

export interface IBackgroundData
{
    color: string;
    image: string;
    pattern: PatternRepeat;
    width: number;
    height: number;
}

export enum PatternRepeat
{
    REPEAT = 1,
    NO_REPEAT,
    REPEAT_X,
    REPEAT_Y
}
